var React = require('react');

function Upgrade (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic"},[React.createElement("circle",{"id":"Oval","cx":"7","cy":"7","r":"7","fill":"#AF30D7","key":0}),React.createElement("path",{"id":"arrow","fillRule":"evenodd","clipRule":"evenodd","d":"M3.18359 7.84352L7.00178 2.86328L10.82 7.84352H8.31087V10.4996H5.69268V7.84352H3.18359Z","fill":"white","key":1})]));
}

Upgrade.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = Upgrade;

Upgrade.default = Upgrade;
